'use strict'

function initializeModal() {
  let $modalPlayer;
  $(document).ready(function () {
    // Open Modal
    $('.js-open-modal').on('click', openModal)

    // Close Modal
    $('.js-close-modal').on('click', closeModal)

    // Instantly open modals that are marked as instant
    $('.js-open-modal-instant').trigger('click')
  })

  function openModal (e) {
    e.preventDefault();
    const $this = $(this)
    const $modalIndicator = $this.data('modal')
    const $modal = $('#' + $modalIndicator)
    $modal.fadeIn(200, () => $modal.addClass('shown'))
    $('body').addClass('no-overflow')
    $('input').blur()
    $('button').blur()
    $('form').blur()
    // Modal video settings
    if ($modalIndicator.indexOf('modal-video') > -1) {
      const $videoid = $this.data('videoid')
      const $player = $modal.find('.video__player')
      $player.attr('data-plyr-provider', 'youtube')
      $player.attr('data-plyr-embed-id', $videoid)
      $modalPlayer = new Plyr($player, {
        autoplay: true,
        youtube: {
          noCookie: true,
          iv_load_policy: 3,
          modestbranding: 1,
          playsinline: 1,
          showinfo: 0,
          rel:0,
          enablejsapi: 1
        }
      })
    }
  }

  function closeModal (e) {
    const $this = $(this)
    const el = $this.closest('.modal__wrapper')
    e.preventDefault();
    el.fadeOut(200, () => el.removeClass('shown'))
    $('body').removeClass('no-overflow')
    if ($modalPlayer != undefined) {
      $modalPlayer.destroy()
    }
  }
}

export default initializeModal
